export default __webpack_public_path__ + "static/flowchart-8b0627a006c57084880b29bba9a170c8.svg";